export default "assets/images/pattern-cf481602.png";